import {NgModule} from '@angular/core';
import {
    DeliveryTourNextDeliveryDatesComponent
} from "@iw-shop/delivery-tour/components/next-delivery-dates/delivery-tour-next-delivery-dates.component";
import {AsyncPipe, DatePipe, JsonPipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {
    DeliveryTourDateAndPeriodSelectionComponent
} from "@iw-shop/delivery-tour/components/date-and-period-selection/delivery-tour-date-and-period-selection..component";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ReactiveFormsModule} from "@angular/forms";
import {
    DeliveryTourMinimumOrderValuesComponent
} from "@iw-shop/delivery-tour/components/minimum-order-values/delivery-tour-minimum-order-values.component";
import {DatePicker} from "primeng/datepicker";
import {PopoverModule } from "primeng/popover";
import {TooltipModule} from "primeng/tooltip";


@NgModule({
    declarations: [
        DeliveryTourNextDeliveryDatesComponent,
        DeliveryTourDateAndPeriodSelectionComponent,
        DeliveryTourMinimumOrderValuesComponent
    ],
    imports: [
        NgForOf,
        DatePipe,
        NgIf,
        AsyncPipe,
        FontAwesomeModule,
        ReactiveFormsModule,
        NgClass,
        DatePicker,
        PopoverModule,
        TooltipModule,
        JsonPipe,

    ],
    providers: [
        DatePipe,
    ],
    exports: [
        DeliveryTourNextDeliveryDatesComponent,
        DeliveryTourDateAndPeriodSelectionComponent,
        DeliveryTourMinimumOrderValuesComponent
    ]
})
export class DeliveryTourModule {
}
